import React from 'react';

const VARIANTS = ['blue', 'white', 'red', 'link', 'success', 'warning', 'info', 'danger'];
const SIZES = { large: 'lg', small: 'sm', xsmall: 'xs', lg: 'lg', sm: 'sm', xs: 'xs' };

/**
 * Delve's primary control. variant/size mirror the app's react-bootstrap
 * bsStyle/bsSize vocabulary so call-site migration is a prop rename.
 *
 * @param {object} props
 * @param {'blue'|'white'|'red'|'link'|'success'|'warning'|'info'|'danger'} [props.variant='white']
 *   Visual style; unknown values fall back to white.
 * @param {'large'|'lg'|'small'|'sm'|'xsmall'|'xs'} [props.size] Omit for the default size.
 * @param {boolean} [props.block] Fill the parent's width.
 * @param {boolean} [props.active] Pressed appearance.
 * @param {string} [props.href] Renders an <a> instead of a <button>.
 * @param {string} [props.type='button'] Button type when not rendering a link.
 */
const Button = React.forwardRef(function Button(
  { variant = 'white', size, block, active, className, href, type, children, ...rest },
  ref
) {
  const classes = [
    'ui-btn',
    `ui-btn--${VARIANTS.includes(variant) ? variant : 'white'}`,
    SIZES[size] && `ui-btn--${SIZES[size]}`,
    block && 'ui-btn--block',
    active && 'active',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (href) {
    return (
      <a ref={ref} className={classes} href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button ref={ref} className={classes} type={type || 'button'} {...rest}>
      {children}
    </button>
  );
});

export default Button;
